<script>
	import Helper from '../Classes/Helper';
	import Product from '../Stores/Product';

	let hide = false;
	let remove = false;

	Product.subscribe(state => {
		if (Helper.is(state)) {
			setTimeout(() => hide = true, 500);
			setTimeout(() => remove = true, 1500);
		}
	});
</script>

<style>
	div.zes-loader {
		top: 0; right: 0; bottom: 0; left: 0;
		background: var(--zes-1-1);
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		transition: opacity .5s ease-out;
		will-change: opacity;
		z-index: 900;
	}

	div.zes-loader.zes-hide {
		opacity: 0;
	}

	div.zes-spinner {
		display: inline-block;
		width: 7em;
		height: 7em;
		border: .5em solid hsl(0deg 100% 100% / .1);
		border-top-color: hsl(0deg 100% 100% / .75);
		border-radius: 50%;
		animation: zes-spin 1s ease-in-out infinite;
	}

	@keyframes zes-spin {
		to {
			transform: rotate(360deg);
		}
	}
</style>

{#if !remove}
	<div class="zes-loader" class:zes-hide="{hide}">
		<div class="zes-spinner"></div>
	</div>
{/if}